// @unocss-include
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx, Icon } from '@a-type/ui';
import { useContext, useEffect, useState } from 'react';
import { VerdantContext } from '../verdant.js';
export function GlobalSyncingIndicator({}) {
    const [syncing, setSyncing] = useState(false);
    const clientDesc = useContext(VerdantContext);
    useEffect(() => {
        if (!(clientDesc === null || clientDesc === void 0 ? void 0 : clientDesc.current))
            return;
        const client = clientDesc.current;
        return client.sync.subscribe('syncingChange', setSyncing);
    }, [clientDesc]);
    if (!clientDesc)
        return null;
    return (_jsxs("div", { className: clsx('fixed top-2 right-2 z-tooltip bg-gray-wash rounded-full p-1 text-xs flex flex-row gap-1 items-center transition-opacity transition-delay-500 opacity-0 pointer-events-none', {
            'opacity-100': syncing,
        }), "aria-hidden": !syncing, children: [_jsx(Icon, { name: "refresh", className: "animate-spin" }), _jsx("span", { children: "Syncing" })] }));
}
//# sourceMappingURL=GlobalSyncingIndicator.js.map